// @ts-nocheck
/* eslint-enable */
/* eslint-disable object-shorthand */
function tagReplace(str) {
  return {
    decodeEntity: function () {
      str = str
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"');
      return this;
    },
    h2ToH3: function () {
      str = str.replace(/<h2[^>]*>/g, '<h3>').replace(/<\/h2>/g, '</h3>');
      return this;
    },
    strongToEmpty: function () {
      str = str.replace(/<strong[^>]*>/g, '').replace(/<\/strong>/g, '');
      return this;
    },
    finalSanitization: function () {
      str = str.replace(/<script[^>]*>/g, '').replace(/<\/script>/g, '');
      return this;
    },
    result: function () {
      return str;
    },
  };
}

export const useHtmlTagSwap = (articlesArray = []) => {
  if (articlesArray.length < 1) {
    return { formattedHtmlString: null };
  }

  const rawHtmlString = articlesArray[0].body;
  const formattedHtmlString = tagReplace(rawHtmlString)
    .decodeEntity()
    .h2ToH3()
    .strongToEmpty()
    .finalSanitization()
    .result();

  return { formattedHtmlString };
};
